<ng-container *transloco="let t">
  <div class="certificate-form">
    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Anamnesis') }}</mat-label>
      <textarea matInput rows="4" [formControl]="anamnesis"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Clinical findings') }}</mat-label>
      <textarea matInput rows="4" [formControl]="clinicalFindings"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Diagnosis') }}</mat-label>
      <textarea matInput rows="3" [formControl]="diagnosis"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Therapy') }}</mat-label>
      <textarea matInput rows="3" [formControl]="therapy"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Follow-up') }}</mat-label>
      <textarea matInput rows="2" [formControl]="followUp"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Notes') }}</mat-label>
      <textarea matInput rows="2" [formControl]="notes"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput [formControl]="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
